import { Flex, Spacer, Text } from "@chakra-ui/react";
import CardDefault from "components/Cards/CardDefault";
import { TagsStatusManutencao } from "components/Tags/TagStatusManutencao";
import { useCurrentAuth } from "core/features/auth/auth.store";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { ManutencaoDto } from "features/manutencao/typings";
import { showError } from "infra/helpers/alerta";
import moment from "moment";
import OutlineButton from "ui/components/Button/OutlineButton";

interface CardItemManutencaoProps {
  item: ManutencaoDto;
}

function CardItemManutencao({ item }: CardItemManutencaoProps) {
  const { auth } = useCurrentAuth();
  const { selecionar } = useCurrentTenant();

  const onSwitchTenant = (tenantId: string) => {
    const _tenant = auth.tenants?.find((tenant) => tenant.id === tenantId);

    if (_tenant) {
      selecionar(_tenant);

      setTimeout(() => {
        window.location.href = `/administracao/manutencao?manutencaoId=${item.id}`;
      }, 100);
    } else {
      showError(
        "Ocorreu um erro ao trocar o condomínio. Tente atualizar a página."
      );
    }
  };

  return (
    <CardDefault mt="16px" p="16px">
      <Flex>
        <Flex flexDir="column" w="60%">
          <Text fontSize="14px" fontWeight="bold">
            {item.nome}
          </Text>

          {item.equipamentos?.length ? (
            <Flex>
              <Text fontSize="12px" fontWeight="300">
                {item.equipamentos
                  .map((equipamento) => equipamento.nome)
                  .join("; ")}
              </Text>
            </Flex>
          ) : null}

          <Flex>
            <Text fontSize="12px" fontWeight="300">
              {item.data ? moment(item.data).format("DD/MM/YYYY") : null}
            </Text>
          </Flex>

          {item.tenant ? (
            <Flex>
              <Text fontSize="11px" fontWeight="500">
                {item.tenant.nome}
              </Text>
            </Flex>
          ) : null}
        </Flex>
        <Spacer />
        <Flex
          flexDir="column"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          {item.status ? (
            <TagsStatusManutencao statusId={item.status.id} data={item.data} />
          ) : null}

          {item.responsavelTecnico ? (
            <Text fontSize="12px" fontWeight="300" mt="auto">
              {item.responsavelTecnico.nome}
            </Text>
          ) : null}
        </Flex>
      </Flex>

      <Flex justifyContent="flex-end" mt="8px">
        {item.tenant ? (
          <OutlineButton ml={3} onClick={() => onSwitchTenant(item.tenant!.id)}>
            Trocar condomínio e ir para a listagem
          </OutlineButton>
        ) : null}
      </Flex>
    </CardDefault>
  );
}

export default CardItemManutencao;
